import { Link, useParams } from 'react-router-dom'
import { allaBegrepp, hittaBegrepp } from '../lib/begrepp'
import { kapitelIndex } from '../lib/content'
import { useSidTitel } from '../lib/seo'

/** En egen sida per begrepp: förklaringen, kapitlet begreppet hör hemma i och
 *  fler begrepp ur samma kapitel. Datan är synkron (begreppsdatabasen ligger i
 *  huvudbundeln för textmarkeringen), så sidan förrenderas komplett utan
 *  förladdning. */
export default function BegreppSida() {
  const { slug } = useParams<{ slug: string }>()
  const post = slug ? hittaBegrepp(slug) : null
  useSidTitel(post ? `${post.begrepp} — begreppsförklaring` : undefined)

  if (!post) {
    return (
      <div className="wrap">
        <div className="dokument">
          <h1>Begreppet finns inte</h1>
          <p>Adressen pekar på ett begrepp som inte finns i läromedlet.</p>
          <Link className="knapp knapp-primar" to="/begrepp">
            Till begreppslistan A–Ö
          </Link>
        </div>
      </div>
    )
  }

  const kapitel = kapitelIndex.find((k) => k.id === post.kapitel_id)
  const relaterade = allaBegrepp.filter((b) => b.kapitel_id === post.kapitel_id && b.slug !== post.slug).slice(0, 8)

  return (
    <div className="wrap">
      <article className="begreppssida">
        <header className="kapitelhuvud">
          <nav className="brodsmula" aria-label="Brödsmulor">
            <Link to="/begrepp">← Begrepp A–Ö</Link>
          </nav>
          <span className="kapitel-nr">Begrepp</span>
          <h1>{post.begrepp}</h1>
        </header>

        <p className="begrepp-forklaring">{post.forklaring}</p>

        {kapitel?.publicerad && kapitel.slug && (
          <p className="begrepp-kalla">
            Begreppet förklaras i{' '}
            <Link to={`/kapitel/${kapitel.slug}`}>
              kapitel {kapitel.id}: {kapitel.titel}
            </Link>{' '}
            i läromedlet Ledarskap och organisation (Gy25).
          </p>
        )}

        {relaterade.length > 0 && (
          <section aria-labelledby="relaterade-rubrik">
            <h2 className="sektionsrubrik" id="relaterade-rubrik">Fler begrepp ur samma kapitel</h2>
            <ul className="begrepp-oversikt">
              {relaterade.map((b) => (
                <li key={b.slug}>
                  <Link to={`/begrepp/${b.slug}`}>{b.begrepp}</Link>
                </li>
              ))}
            </ul>
          </section>
        )}
      </article>
    </div>
  )
}
